// extracted by mini-css-extract-plugin
export var expandedRowWrapper = "_2v-6";
export var headerCell = "_2v-2";
export var loadingStateContent = "_2v-8";
export var rowWrapper = "_2v-4";
export var stickyAggregationCell = "_2v-b";
export var stickyAggregationRow = "_2v-7";
export var stickyColumnCell = "_2v-a";
export var stickyColumnHeaderCell = "_2v-9";
export var table = "_2v-1";
export var virtualRowWrapper = "_2v-5";
export var virtualTableBodyFiller = "_2v-d";
export var virtualTableBodyFillerBottom = "_2v-e";
export var virtualTableContainer = "_2v-0";
export var virtualTableContainerFill = "_2v-c";
export var white = "_2v-3";